import VitalSidebar from './vital-sidebar';

export default VitalSidebar;
